import { Flex, Progress, Table, Text } from '@approvalmax/ui/src/components';
import { FC, memo } from 'react';

import { useGetInvalidItems } from '../../OffboardUserPopupContent.hooks';
import { ApprovalWorkflowsColumns } from './ApprovalWorkflows.constants';
import { useApprovalWorkflowsData } from './ApprovalWorkflows.hooks';
import { messages } from './ApprovalWorkflows.messages';
import { ApprovalWorkflowsProps } from './ApprovalWorkflows.types';

const ApprovalWorkflows: FC<ApprovalWorkflowsProps> = memo((props) => {
    const { isLoading, workflows, companyId } = props;

    const data = useApprovalWorkflowsData(companyId, workflows);

    const isEmpty = data.length === 0 && !isLoading;

    const invalidItems = useGetInvalidItems(data);

    return (
        <Flex direction='column'>
            <Table
                columns={ApprovalWorkflowsColumns}
                data={isLoading ? [] : data}
                invalidItems={invalidItems}
                headerColor='white100'
            />

            {isLoading && (
                <Flex justifyContent='center'>
                    <Progress shape='circle' />
                </Flex>
            )}

            {isEmpty && (
                <Text font='body' textAlign='center' color='midnight60'>
                    {messages.noData}
                </Text>
            )}
        </Flex>
    );
});

export default ApprovalWorkflows;
